import { Box, CircularProgress, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

export const HomeLoadingState = ({ label }: { label: string }) => {
  const classes = useStyles();
  return (
    <Box className={classes.root} role="status">
      <CircularProgress size={20} />
      <Typography>{label}</Typography>
    </Box>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    minHeight: 88,
    color: theme.palette.text.secondary,
  },
}));
